































import { Component, Vue, Prop } from 'vue-property-decorator'
import { UnitFileData, removeUnitFile } from '@/api/heritageUnit/unitBase'
import { removeEighthUnitFile } from '@/api/eighthHeritage/eighthHeritage'
import { thumbnailServer } from '@/api/common/upload'
import { newGuid } from '@/configs/functions'
import { AttachInfo } from '@/api/common/attach'

@Component
export default class UnitFileList extends Vue {
  public name = 'UnitFileList'

  @Prop({ default: 0 })
  public category!: number //0.HeritageUnitFileList 1.EighthUnitFileList
  @Prop({ default: 0 })
  public unitId!: number
  @Prop({ default: 1 }) //1照片 2图纸 3四有中的照片 4四有中的图纸
  public fileType!: number
  @Prop({ default: 1 })
  public referType!: number

  public modifyIndex: number = -1
  //由父级传入
  public fileList: UnitFileData[] = []

  public emptyAttach: AttachInfo = {
    Id: 0,
    TempGuid: '',
    Name: '',
    Ext: '',
    Path: '',
    SavePath: '',
    Size: 0,
    Comments: ''
  }
  public emptyForm: UnitFileData = {
    Id: 0,
    UnitId: 0,
    FileType: 0, //0:图片 1:图纸
    FileCode: '', // 代码
    FileName: '', // 名称
    AttachId: 0,
    FileCreateDate: new Date(), // 制作日期
    FileMade: '', // 制作人
    FileSpec: '',
    Specification: '',
    NewUserId: 0,
    NewDate: new Date(),

    FileTypeName: '',
    AttachType: 0,
    AttachGuid: '',
    AttInfo: this.emptyAttach
  }
  public setData(data: UnitFileData[]) {
    this.fileList = data
  }
  public getData() {
    return this.fileList
  }

  public showDetail(index: number) {
    var f = this.fileList[index]
    window.eventBus.$emit('openUnitFileDetail', f)
  }

  public getFileUrl(f: AttachInfo) {
    return thumbnailServer(f.Id, f.TempGuid, f.Name)
  }
  // dynamic component
  public $refs!: {
    // unitFileCtrl: UnitFileForm
  }
  public addFile() {
    this.modifyIndex = -1
    // this.$refs.unitFileCtrl.newData(this.fileType, this.referType)
    var newFile = Object.assign({}, this.emptyForm)
    newFile.AttachType = this.referType
    newFile.FileType = this.fileType
    newFile.UnitId = this.unitId
    this.showFileForm(newFile)
  }
  public editFile(index: number) {
    this.modifyIndex = index
    var item = this.fileList[index]
    // this.$refs.unitFileCtrl.modifyData(file)
    var file = Object.assign({}, item)
    this.showFileForm(file)
  }
  public updateFile(data: UnitFileData) {
    if (this.modifyIndex >= 0) {
      // this.fileList[this.modifyIndex] = data
      this.$set(this.fileList, this.modifyIndex, data)
    } else {
      this.fileList.push(data)
    }
    this.modifyIndex = -1
  }
  public closeFileForm() {
    console.log('closeFileForm')
  }
  public delFile(index: number) {
    this.$confirm(`确定要删除该项吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        var file = this.fileList[index]
        if (file.Id > 0 || file.AttachId > 0) {
          const promist =
            this.category == 0
              ? removeUnitFile(file.Id, file.AttachId)
              : removeEighthUnitFile(file.Id, file.AttachId)
          promist.then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.fileList.splice(index, 1)
          })
        } else {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.fileList.splice(index, 1)
        }
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '操作已取消'
        })
      })
  }

  //每次调用组件都生成一个guid，用来在上传完成后的回传
  public uploadGuid: string = ''
  public showFileForm(file: UnitFileData) {
    if (this.uploadGuid == '') {
      this.uploadGuid = newGuid()
    }
    //第八批
    if (this.category == 1) {
      this.uploadGuid += '_EighthUnit'
    }
    window.eventBus.$emit('openUnitFileForm', {
      targetId: this.uploadGuid,
      data: file
    })
  }
  public mounted() {
    window.eventBus.$on('submitUnitFileForm', (info: any) => {
      if (info.targetId == this.uploadGuid) {
        this.updateFile(info.data)
      }
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('submitUnitFileForm')
  }
}
